<template>
	<div class="status-page">
		<div class="bg-light">
			<app-header v-if="windowWidth >= mobileBreakpoint" :nav="false" />
			<div class="container clearfix">
				<div class="page-content space-left float-lg-left">
					<header>
						<h1 v-html="cms.errorHeadHtml"></h1>
					</header>
					<div
						v-if="windowWidth < mobileBreakpoint"
						class="mobile-image-container"
					>
						<img
							src="images/statuses/error-500.jpg"
							alt="Akcja nie powiodła się"
							class="img-fluid"
						/>
					</div>
					<p
						v-html="cms.errorSubHeadHtml"
						class="lead"
						style="margin-bottom: 30px"
					></p>
					<router-link to="/" class="btn btn-primary"
						>do strony głównej</router-link
					>
				</div>
				<img
					v-if="windowWidth >= mobileBreakpoint"
					src="images/statuses/error-500.jpg"
					alt="Akcja nie powiodła się"
					class="float-right"
					style="margin: -99px -15px 30px 0"
				/>
			</div>
		</div>
		<status-page-footer />
	</div>
</template>

<script>
import AppHeader from '@/components/AppHeader';
import StatusPageFooter from '@/views/StatusPage/Partial/FooterView';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			/* eslint-disable */
			cms: {
				errorHeadHtml: ERROR_HEAD_HTML,
				errorSubHeadHtml: ERROR_SUB_HEAD_HTML,
			},
			/* eslint-enable */
		};
	},
	components: {
		AppHeader,
		StatusPageFooter,
	},
	computed: {
		...mapGetters(['windowWidth', 'mobileBreakpoint']),
	},
};
</script>
